import {Component, Input} from '@angular/core';

import {ItemLabelInfoModalComponent} from '../item-label-info-modal/item-label-info-modal.component';
import {MyDeviceRequestContainerModel} from '../../models/my-device-request-container.model';
import {MyNotDeviceRequestContainerModel} from '../../models/my-not-device-request-container.model';
import {ModalDynamicV3Service} from '../../../../shared-modal-dynamic/services/modal-dynamic-v3-service.service';
import {IModalDialogV3} from '../../../../shared-modal-dynamic/interfaces/i-modal-dialog-v3';

@Component({
    selector: 'app-product-label',
    templateUrl: './product-label.component.html',
    styleUrls: ['./product-label.component.scss']
})
export class ProductLabelComponent {

    @Input() orderItemContainer: MyDeviceRequestContainerModel | MyNotDeviceRequestContainerModel;
    @Input() activateHover = true;
    @Input() showTitle = true;

    @Input() showArrow = true;

    private dialogRef: IModalDialogV3;

    constructor(
        private modalDynamicV3Service: ModalDynamicV3Service) {
    }

    public isArrowVisible(): boolean {
        return this.showArrow && !this.orderItemContainer.isDevice && this.orderItemContainer['parent'];
    }


    public openInfoPanel(elementRef: HTMLElement) {


        if (!this.activateHover || !this.orderItemContainer.itemToOrder.images ||
            this.orderItemContainer.itemToOrder.images.length === 0 || !this.orderItemContainer.itemToOrder.images[0]) {
            return;
        }

        const dialogHeight = 200;
        const deltaX = 10;
        const deltaY = -10;

        const windowHeight = window.innerHeight;

        let top = Math.floor(+elementRef.getBoundingClientRect().top) + deltaY;

        if (windowHeight - dialogHeight < top) {
            top = windowHeight - (dialogHeight + 20);
        }

        const left = Math.floor(+elementRef.getBoundingClientRect().right) + deltaX;


        this.dialogRef = this.modalDynamicV3Service
            .open(ItemLabelInfoModalComponent, {
                model: {
                    title: this.getItemSKU(),
                    imageUrl: this.orderItemContainer.itemToOrder.images[0],
                    top: top + 'px',
                    left: left + 'px'
                }
            });
    }


    public closeInfoPanel() {
        if (this.dialogRef) {
            this.dialogRef.close();
        }
    }

    public getItemSKU() {
        return this.orderItemContainer.itemToOrder.sku;
    }

    public isTitleVisible() {
        return this.showTitle && this.orderItemContainer && this.orderItemContainer.itemToOrder && this.orderItemContainer.itemToOrder.modelTitle
    }
}
